module.exports = __webpack_public_path__ + "static/bowl_of_commanding_water_elementals-6c788ec9ac409daeb56cb0f088f9dcaa.jpeg";